<template>
    <div class="platform-container">
        <el-card class="box-card">
            <el-tabs v-model="areaType" @tab-click="handleClick">
                <el-tab-pane label="上海" name="2"></el-tab-pane>
                <el-tab-pane label="江苏" name="1"></el-tab-pane>
                <el-tab-pane label="浙江" name="4"></el-tab-pane>
                <el-tab-pane label="安徽" name="3"></el-tab-pane>
            </el-tabs>

            <el-tabs tab-position="left" v-model="activeTab">
                <!-- Banner图管理 -->
                <el-tab-pane label="Banner图" name="banner">
                    <el-card>
                        <upload-image
                            :width="300"
                            :height="150"
                            :maxSize="20"
                            :value="bannerForm.bannerUrl"
                            key="banner"
                            ref="uploadImage"
                            @on-change="handleImageChange($event, 'banner')"
                            @on-remove="handleImageRemove"
                        />
                        <div class="banner-linkUrl">
                            <span class="label-name">跳转链接：</span>
                            <el-input
                                placeholder="请输入跳转链接"
                                v-model="bannerForm.linkUrl"
                                style="width: 70%"
                                clearable
                            >
                            </el-input>
                        </div>
                        <div class="banner-submit">
                            <el-button type="primary" @click="onBannerSubmit"
                                >提交</el-button
                            >
                            <el-button @click="onBannerReset">重置</el-button>
                        </div>
                    </el-card>
                </el-tab-pane>

                <!-- 核心资源 -->
                <el-tab-pane
                    label="核心资源"
                    name="core"
                    v-if="areaType !== '1'"
                >
                    <el-card>
                        <div class="button-group">
                            <el-button :type="coreList.length < 4 ? 'primary' : 'info'" @click="handleAddCore"
                                >新增</el-button
                            >
                        </div>
                        <el-table
                            :data="coreList"
                            border
                            style="width: 100%"
                            v-loading="coreLoading"
                        >
                            <el-table-column
                                prop="title"
                                label="标题"
                            ></el-table-column>
                            <el-table-column
                                prop="info"
                                label="简介"
                            ></el-table-column>
                            <el-table-column label="图片" width="180">
                                <template #default="scope">
                                    <el-image
                                        style="width: 100px; height: 60px"
                                        :src="scope.row.photoUrl"
                                        fit="cover"
                                    >
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="sort"
                                label="排序"
                                width="100"
                            ></el-table-column>
                            <el-table-column label="操作" width="150">
                                <template #default="scope">
                                    <el-button
                                        type="text"
                                        @click="handleEditCore(scope.row)"
                                        >编辑</el-button
                                    >
                                    <el-button
                                        type="text"
                                        style="color: #ff0000"
                                        @click="handleDelete(scope.row)"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-tab-pane>

                <!-- 特色服务 -->
                <el-tab-pane
                    label="特色服务"
                    name="service"
                    v-if="areaType !== '1'"
                >
                    <el-card>
                        <div class="button-group">
                            <el-button :type="serviceList.length < 4 ? 'primary' : 'info'" @click="handleAdd"
                                >新增</el-button
                            >
                        </div>
                        <el-table
                            :data="serviceList"
                            border
                            style="width: 100%"
                            v-loading="serviceLoading"
                        >
                            <el-table-column
                                prop="title"
                                label="标题"
                            ></el-table-column>
                            <el-table-column
                                prop="info"
                                label="简介"
                            ></el-table-column>
                            <el-table-column label="图片" width="180">
                                <template #default="scope">
                                    <el-image
                                        style="width: 100px; height: 60px"
                                        :src="scope.row.photoUrl"
                                        fit="cover"
                                    >
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="sort"
                                label="排序"
                                width="100"
                            ></el-table-column>
                            <el-table-column label="操作" width="180">
                                <template #default="scope">
                                    <el-button
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        >编辑</el-button
                                    >
                                    <el-button
                                        type="text"
                                        @click="handleDelete(scope.row)"
                                        style="color: #ff0000"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-tab-pane>

                <!-- 政策支持 -->
                <el-tab-pane
                    label="政策支持"
                    name="policy"
                    v-if="areaType !== '1'"
                >
                    <el-card>
                        <div class="button-group">
                            <el-button :type="policyList.length < 4 ? 'primary' : 'info'" @click="handleAdd"
                                >新增</el-button
                            >
                        </div>
                        <el-table
                            :data="policyList"
                            border
                            style="width: 100%"
                            v-loading="policyLoading"
                        >
                            <el-table-column
                                prop="title"
                                label="标题"
                            ></el-table-column>
                            <el-table-column
                                prop="info"
                                label="简介"
                            ></el-table-column>
                            <el-table-column
                                prop="linkUrl"
                                label="链接"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column label="图片" width="180">
                                <template #default="scope">
                                    <el-image
                                        style="width: 100px; height: 60px"
                                        :src="scope.row.photoUrl"
                                        fit="cover"
                                    >
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="sort"
                                label="排序"
                                width="100"
                            ></el-table-column>
                            <el-table-column label="操作" width="180">
                                <template #default="scope">
                                    <el-button
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        >编辑</el-button
                                    >
                                    <el-button
                                        type="text"
                                        @click="handleDelete(scope.row)"
                                        style="color: #ff0000"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-tab-pane>

                <!-- 应用案例 -->
                <el-tab-pane
                    label="应用案例"
                    name="case"
                    v-if="areaType !== '1'"
                >
                    <el-card>
                        <div class="button-group">
                            <el-button type="primary" @click="handleAdd"
                                >新增</el-button
                            >
                        </div>
                        <el-table
                            :data="caseList"
                            border
                            style="width: 100%"
                            v-loading="caseLoading"
                        >
                            <el-table-column
                                prop="title"
                                label="标题"
                            ></el-table-column>
                            <el-table-column label="图片" width="180">
                                <template #default="scope">
                                    <el-image
                                        style="width: 100px; height: 60px"
                                        :src="scope.row.photoUrl"
                                        fit="cover"
                                    >
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="sort"
                                label="排序"
                                width="100"
                            ></el-table-column>
                            <el-table-column label="操作" width="180">
                                <template #default="scope">
                                    <el-button
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        >编辑</el-button
                                    >
                                    <el-button
                                        type="text"
                                        @click="handleDelete(scope.row)"
                                        style="color: #ff0000"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-container">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 50]"
                                :page-size="size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            >
                            </el-pagination>
                        </div>
                    </el-card>
                </el-tab-pane>

                <!-- 政策新闻 -->
                <el-tab-pane
                    label="政策新闻"
                    name="news"
                    v-if="areaType === '1'"
                >
                    <el-tabs v-model="newsType" @tab-click="handleNewsClick">
                        <el-tab-pane label="新闻动态" name="1">
                            <!-- 新闻动态列表 -->
                            <el-card>
                                <div class="search-box">
                                    <el-input
                                        v-model="newsTitle"
                                        placeholder="请输入标题"
                                        style="width: 200px; margin-right: 10px"
                                        @keyup.enter.native="handleNewsSearch"
                                        clearable
                                    ></el-input>
                                    <el-button
                                        type="primary"
                                        @click="handleNewsSearch"
                                        >搜索</el-button
                                    >
                                    <el-button @click="handleNewsReset"
                                        >重置</el-button
                                    >
                                </div>
                                <div class="button-group button-group-mt">
                                    <el-button
                                        type="primary"
                                        @click="handleAddNews1"
                                        >新增</el-button
                                    >
                                    <el-button
                                        type="danger"
                                        @click="handleBatchDelete1"
                                        :disabled="selectedRows.length === 0"
                                        >批量删除</el-button
                                    >
                                </div>
                                <el-table
                                    :data="newsList"
                                    border
                                    style="width: 100%"
                                    v-loading="newsLoading"
                                    @selection-change="handleSelectionChange"
                                >
                                    <el-table-column
                                        type="selection"
                                        width="55"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        type="index"
                                        label="序号"
                                        width="80"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="title"
                                        label="标题"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="info"
                                        label="内容缩略"
                                        show-overflow-tooltip
                                    >
                                        <template slot-scope="scope">
                                            <span
                                                >{{
                                                    scope.row.info
                                                        .replace(/<[^>]+>/g, "")
                                                        .slice(0, 100)
                                                }}{{
                                                    scope.row.info.length > 100
                                                        ? "..."
                                                        : ""
                                                }}</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="图片" width="180">
                                        <template #default="scope">
                                            <el-image
                                                style="
                                                    width: 100px;
                                                    height: 60px;
                                                "
                                                :src="scope.row.photoUrl"
                                                fit="cover"
                                            >
                                            </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="createTime"
                                        label="添加时间"
                                        width="180"
                                    ></el-table-column>
                                    <el-table-column label="操作" width="180">
                                        <template #default="scope">
                                            <el-button
                                                type="text"
                                                @click="
                                                    handleEditNews1(scope.row)
                                                "
                                                >编辑</el-button
                                            >
                                            <el-button
                                                type="text"
                                                style="color: #ff0000"
                                                @click="
                                                    handleDeleteNews(scope.row)
                                                "
                                                >删除</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination-container">
                                    <el-pagination
                                        @size-change="handleNewsSizeChange"
                                        @current-change="
                                            handleNewsCurrentChange
                                        "
                                        :current-page="newsCurrentPage"
                                        :page-sizes="[10, 20, 30, 50]"
                                        :page-size="newsSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="newsTotal"
                                    ></el-pagination>
                                </div>
                            </el-card>
                        </el-tab-pane>
                        <!-- 政策指南 -->
                        <el-tab-pane label="政策指南" name="2">
                            <el-card>
                                <div class="search-box">
                                    <el-input
                                        v-model="policyGuideTitle"
                                        placeholder="请输入标题"
                                        style="width: 200px; margin-right: 10px"
                                        @keyup.enter.native="getPolicyGuideList"
                                        clearable
                                    ></el-input>
                                    <el-button
                                        type="primary"
                                        @click="getPolicyGuideList"
                                        >搜索</el-button
                                    >
                                    <el-button @click="handlePolicyReset"
                                        >重置</el-button
                                    >
                                </div>
                                <div class="button-group button-group-mt">
                                    <el-button
                                        type="primary"
                                        @click="handleAddNews2"
                                        >新增</el-button
                                    >
                                </div>
                                <el-table
                                    :data="policyGuideList"
                                    border
                                    style="width: 100%"
                                    v-loading="policyGuideLoading"
                                    @selection-change="
                                        handlePolicyGuideSelectionChange
                                    "
                                >
                                    <el-table-column
                                        type="index"
                                        label="序号"
                                        width="80"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="title"
                                        label="标题"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="info"
                                        label="简介"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="linkUrl"
                                        label="链接"
                                        show-overflow-tooltip
                                    ></el-table-column>
                                    <!-- <el-table-column label="图片" width="180">
                                        <template #default="scope">
                                            <el-image
                                                style="
                                                    width: 100px;
                                                    height: 60px;
                                                "
                                                :src="scope.row.photoUrl"
                                                fit="cover"
                                            >
                                            </el-image>
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column
                                        prop="sort"
                                        label="排序"
                                        width="100"
                                    ></el-table-column>
                                    <el-table-column label="操作" width="180">
                                        <template #default="scope">
                                            <el-button
                                                type="text"
                                                @click="
                                                    handleEditNews2(scope.row)
                                                "
                                                >编辑</el-button
                                            >
                                            <el-button
                                                type="text"
                                                style="color: #ff0000"
                                                @click="
                                                    handleDeletePolicyGuide(
                                                        scope.row
                                                    )
                                                "
                                                >删除</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination-container">
                                    <el-pagination
                                        @size-change="
                                            handlePolicyGuideSizeChange
                                        "
                                        @current-change="
                                            handlePolicyGuideCurrentChange
                                        "
                                        :current-page="policyGuideCurrentPage"
                                        :page-sizes="[10, 20, 30, 50]"
                                        :page-size="policyGuideSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="policyGuideTotal"
                                    ></el-pagination>
                                </div>
                            </el-card>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <!-- 核心资源编辑对话框 -->
        <core-form
            ref="CoreFormRef"
            :areaType="areaType"
            @refresh="getCoreData"
        ></core-form>
        <!-- 特色服务编辑对话框 -->
        <service-form
            ref="ServiceFormRef"
            :areaType="areaType"
            @refresh="getServiceData"
        ></service-form>
        <!-- 政策支持编辑对话框 -->
        <policy-form
            ref="PolicyFormRef"
            :areaType="areaType"
            @refresh="getPolicyData"
        ></policy-form>
        <!-- 应用案例编辑对话框 -->
        <case-form
            ref="CaseFormRef"
            :areaType="areaType"
            @refresh="getCaseData"
        ></case-form>
        <!-- 政策新闻编辑对话框 -->
        <news-form1
            ref="NewsForm1Ref"
            :areaType="areaType"
            @refresh="getNewsList"
        ></news-form1>
        <news-form2
            ref="NewsForm2Ref"
            :areaType="areaType"
            @refresh="getPolicyGuideList"
        ></news-form2>
    </div>
</template>

<script>
import {
    areaPlatformList, //banner图 - 列表
    areaPlatformSubmit, //banner图 - 新增/编辑
    areaCoreResourceList, //核心资源 - 列表
    areaCoreResourceRemove, //核心资源 - 删除
    areaFeaturedServiceList, //特色服务 - 列表
    areaFeaturedServiceRemove, //特色服务 - 删除
    areaPolicySupportList, //政策支持 - 列表
    areaPolicySupportRemove, //政策支持 - 删除
    areaApplicationCaseList, //应用案例 - 列表
    areaApplicationCaseRemove, //应用案例 - 删除
    areaNewsList, //新闻动态 - 列表
    areaNewsRemove, //新闻动态 - 删除
    areaPolicyList, //政策指南 - 列表
    areaPolicyRemove, //政策指南 - 删除
} from "@/api/admin";
import CoreForm from "@/views/system/components/LocalPlatform/coreForm.vue";
import ServiceForm from "@/views/system/components/LocalPlatform/serviceForm.vue";
import PolicyForm from "@/views/system/components/LocalPlatform/policyForm.vue";
import CaseForm from "@/views/system/components/LocalPlatform/caseForm.vue";
import NewsForm1 from "@/views/system/components/LocalPlatform/newsForm1.vue";
import NewsForm2 from "@/views/system/components/LocalPlatform/newsForm2.vue";
export default {
    name: "LocalPlatform",
    components: {
        CoreForm,
        ServiceForm,
        PolicyForm,
        CaseForm,
        NewsForm1,
        NewsForm2,
    },
    data() {
        return {
            selectedRows: [], // 选中的行数据
            areaType: "2",
            activeTab: "banner",
            dialogVisible: false,
            dialogTitle: "",
            form: {
                title: "",
                info: "",
                linkUrl: "",
                photoUrl: "",
            },
            bannerForm: {
                linkUrl: "",
                bannerUrl: "",
            },
            coreList: [],
            serviceList: [],
            policyList: [],
            caseList: [],
            // 分页相关数据
            size: 10,
            currentPage: 1,
            total: 0,
            // loading状态
            bannerLoading: false,
            coreLoading: false,
            serviceLoading: false,
            policyLoading: false,
            caseLoading: false,
            // 政策新闻相关
            newsType: "1",
            newsTitle: "",
            newsList: [],
            newsLoading: false,
            newsTotal: 0,
            newsCurrentPage: 1,
            newsSize: 10,
            policyGuideList: [], // 政策指南列表数据
            policyGuideLoading: false, // 政策指南加载状态
            policyGuideTitle: "", // 政策指南搜索标题
            policyGuideCurrentPage: 1, // 政策指南当前页
            policyGuideSize: 10, // 政策指南每页条数
            policyGuideTotal: 0, // 政策指南总条数
            selectedPolicyGuides: [], // 选中的政策指南
        };
    },
    watch: {
        areaType: {
            handler(newVal) {
                this.activeTab = "banner";
                this.getBannerData();
                if (this.activeTab === "core") {
                    this.getCoreData();
                } else if (this.activeTab === "service") {
                    this.getServiceData();
                }
            },
            immediate: false,
        },
        activeTab: {
            handler(newVal) {
                if (newVal === "core") {
                    this.getCoreData();
                } else if (newVal === "service") {
                    this.getServiceData();
                } else if (newVal === "policy") {
                    this.getPolicyData();
                } else if (newVal === "case") {
                    this.getCaseData();
                } else if (newVal === "news") {
                    this.getNewsList();
                }
            },
        },
        newsType: {
            immediate: true,
            handler(newVal) {
                if (newVal === "1") {
                    this.getNewsList();
                } else if (newVal === "2") {
                    this.getPolicyGuideList();
                }
            },
        },
    },
    created() {
        this.getBannerData();
    },
    methods: {
        // 表格多选框选中数据
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        // 批量删除新闻动态
        handleBatchDelete1() {
            if (this.selectedRows.length === 0) {
                this.$message.warning("请选择要删除的数据");
                return;
            }
            this.$confirm("确认删除选中的数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const ids = this.selectedRows.map((item) => item.id);
                    // TODO: 调用批量删除接口
                    areaNewsRemove(ids.join(",")).then(() => {
                        this.$message.success("删除成功");
                        this.getNewsList();
                    });
                })
                .catch(() => {});
        },
        // 批量删除政策指南
        handleBatchDelete2() {
            if (this.selectedRows.length === 0) {
                this.$message.warning("请选择要删除的数据");
                return;
            }
            this.$confirm("确认删除选中的数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const ids = this.selectedRows.map((item) => item.id);
                    // TODO: 调用批量删除接口
                    areaNewsRemove(ids.join(",")).then(() => {
                        this.$message.success("删除成功");
                        this.getNewsList();
                    });
                })
                .catch(() => {});
        },
        // 获取核心资源列表数据
        async getCoreData() {
            try {
                const res = await areaCoreResourceList({
                    areaType: this.areaType,
                });
                this.coreList = res.data.records || [];
            } catch (error) {
                console.error("获取核心资源列表数据失败:", error);
                this.$message.error("获取数据失败");
            }
        },
        // 获取banner图数据
        async getBannerData() {
            this.bannerLoading = true;
            try {
                const res = await areaPlatformList({
                    areaType: this.areaType,
                });
                if (res.data.total > 0) {
                    this.bannerForm = res.data.records[0];
                } else {
                    this.bannerForm = {};
                }
            } catch (error) {
                console.error("获取banner图数据失败:", error);
            } finally {
                this.bannerLoading = false;
            }
        },
        // 上传banner图提交
        async onBannerSubmit() {
            if (!this.bannerForm.bannerUrl) {
                this.$message.warning("请上传banner图片");
                return;
            }
            try {
                await areaPlatformSubmit({
                    ...this.bannerForm,
                    areaType: this.areaType,
                });
                this.$message.success("保存成功");
                this.getBannerData(); // 重新获取数据
            } catch (error) {
                console.error("保存banner图失败:", error);
                this.$message.error("保存失败");
            }
        },
        // 上传banner图重置
        onBannerReset() {
            this.bannerForm = {};
            this.$refs.uploadImage.clearFiles();
        },
        // 新增核心资源
        handleAddCore() {
            // 判断至多添加四条数据
            if (this.coreList.length >= 4) {
                this.$message.warning("至多添加四条数据");
                return;
            }
            this.$refs.CoreFormRef.open();
        },
        // 编辑核心资源
        handleEditCore(row) {
            this.$refs.CoreFormRef.open(row);
        },
        handleImageChange(file, type) {
            if (type === "banner") {
                this.bannerForm.bannerUrl = file;
            }
        },
        handleImageRemove(type) {
            if (type === "banner") {
                this.bannerForm.bannerUrl = "";
            }
        },
        handleClick(tab, event) {},
        handleNewsClick(tab, event) {},
        handleNewsTypeChange() {
            this.newsTitle = "";
            this.getNewsList();
        },
        handleAddNews1() {
            this.$refs.NewsForm1Ref.open();
        },
        handleEditNews1(row) {
            this.$refs.NewsForm1Ref.open(row);
        },
        handleAddNews2() {
            this.$refs.NewsForm2Ref.open();
        },
        handleEditNews2(row) {
            this.$refs.NewsForm2Ref.open(row);
        },
        // 获取特色服务列表数据
        async getServiceData() {
            this.serviceLoading = true;
            try {
                const res = await areaFeaturedServiceList({
                    areaType: this.areaType,
                });
                this.serviceList = res.data.records || [];
            } catch (error) {
                console.error("获取特色服务列表数据失败:", error);
                this.$message.error("获取数据失败");
            } finally {
                this.serviceLoading = false;
            }
        },
        // 获取政策支持列表数据
        async getPolicyData() {
            try {
                const res = await areaPolicySupportList({
                    areaType: this.areaType,
                });
                this.policyList = res.data.records || [];
            } catch (error) {
                console.error("获取政策支持列表数据失败:", error);
                this.$message.error("获取数据失败");
            }
        },
        // 获取应用案例列表数据
        async getCaseData() {
            try {
                const res = await areaApplicationCaseList({
                    areaType: this.areaType,
                    size: this.size,
                    current: this.currentPage,
                });
                this.caseList = res.data.records || [];
                this.total = res.data.total || 0;
            } catch (error) {
                console.error("获取应用案例列表数据失败:", error);
                this.$message.error("获取数据失败");
            }
        },
        // 处理每页显示条数变化
        handleSizeChange(val) {
            this.size = val;
            this.getCaseData();
        },
        // 处理当前页变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCaseData();
        },
        handleAdd() {
            if (this.activeTab === "service") {
                // 判断至多添加四条数据
                if (this.serviceList.length >= 4) {
                    this.$message.warning("至多添加四条数据");
                    return;
                }
                // 打开服务表单
                this.$refs.ServiceFormRef.open();
            } else if (this.activeTab === "policy") {
                // 判断至多添加四条数据
                if (this.policyList.length >= 4) {
                    this.$message.warning("至多添加四条数据");
                    return;
                }
                // 打开政策表单
                this.$refs.PolicyFormRef.open();
            } else if (this.activeTab === "case") {
                // 打开应用案例表单
                this.$refs.CaseFormRef.open();
            } else {
                this.dialogTitle = "新增";
                this.dialogVisible = true;
                this.form = {
                    title: "",
                    info: "",
                    linkUrl: "",
                    photoUrl: "",
                };
            }
        },
        handleEdit(row) {
            if (this.activeTab === "service") {
                this.$refs.ServiceFormRef.open(row);
            } else if (this.activeTab === "policy") {
                this.$refs.PolicyFormRef.open(row);
            } else if (this.activeTab === "case") {
                this.$refs.CaseFormRef.open(row);
            } else {
                this.dialogTitle = "编辑";
                this.dialogVisible = true;
                this.form = { ...row };
            }
        },
        handleDelete(row) {
            if (
                this.activeTab === "core" ||
                this.activeTab === "service" ||
                this.activeTab === "policy" ||
                this.activeTab === "case"
            ) {
                this.$confirm("确认删除该记录?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        try {
                            if (this.activeTab === "core") {
                                await areaCoreResourceRemove(row.id);
                                this.getCoreData();
                            } else if (this.activeTab === "service") {
                                await areaFeaturedServiceRemove(row.id);
                                this.getServiceData();
                            } else if (this.activeTab === "policy") {
                                await areaPolicySupportRemove(row.id);
                                this.getPolicyData();
                            } else if (this.activeTab === "case") {
                                await areaApplicationCaseRemove(row.id);
                                this.getCaseData();
                                await areaFeaturedServiceRemove(row.id);
                                this.getServiceData();
                            }
                            this.$message.success("删除成功");
                        } catch (error) {
                            console.error("删除失败:", error);
                            this.$message.error("删除失败");
                        }
                    })
                    .catch(() => {});
            }
        },
        handleSubmit() {
            // 提交表单
            this.dialogVisible = false;
            this.$message.success("保存成功");
        },
        // 新闻动态列表
        async getNewsList() {
            this.newsLoading = true;
            try {
                const res = await areaNewsList({
                    areaType: this.areaType,
                    current: this.newsCurrentPage,
                    size: this.newsSize,
                    title: this.newsTitle,
                });
                this.newsList = res.data.records || [];
                this.newsTotal = res.data.total;
            } catch (error) {
                console.error("获取政策新闻列表失败:", error);
                this.$message.error("获取数据失败");
            } finally {
                this.newsLoading = false;
            }
        },
        handleNewsSearch() {
            this.newsCurrentPage = 1;
            this.getNewsList();
        },
        // 新闻动态重置
        handleNewsReset() {
            this.newsTitle = "";
            this.newsCurrentPage = 1;
            this.getNewsList();
        },
        // 政策指南重置
        handlePolicyReset() {
            this.policyGuideTitle = "";
            this.policyGuideCurrentPage = 1;
            this.getPolicyGuideList();
        },
        handleNewsSizeChange(val) {
            this.newsSize = val;
            this.getNewsList();
        },
        handleNewsCurrentChange(val) {
            this.newsCurrentPage = val;
            this.getNewsList();
        },
        // 新闻动态删除
        async handleDeleteNews(row) {
            try {
                await this.$confirm("确认删除该条记录?", "提示", {
                    type: "warning",
                });
                await areaNewsRemove(row.id);
                this.$message.success("删除成功");
                this.getNewsList();
            } catch (error) {
                console.error("删除失败:", error);
            }
        },
        // 获取政策指南列表
        async getPolicyGuideList() {
            this.policyGuideLoading = true;
            try {
                const res = await areaPolicyList({
                    current: this.policyGuideCurrentPage,
                    size: this.policyGuideSize,
                    areaType: this.areaType,
                    title: this.policyGuideTitle,
                });
                this.policyGuideList = res.data.records;
                this.policyGuideTotal = res.data.total;
            } catch (error) {
                console.error("获取政策指南列表失败:", error);
                this.$message.error("获取政策指南列表失败");
            }
            this.policyGuideLoading = false;
        },
        // 删除单条政策指南
        async handleDeletePolicyGuide(row) {
            try {
                await this.$confirm("确认删除该政策指南吗？", "提示", {
                    type: "warning",
                });
                await areaPolicyRemove(row.id);
                this.$message.success("删除成功");
                this.getPolicyGuideList();
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除政策指南失败:", error);
                    this.$message.error("删除失败");
                }
            }
        },
        // 批量删除政策指南
        async handleBatchDeletePolicyGuides() {
            if (this.selectedPolicyGuides.length === 0) {
                this.$message.warning("请选择要删除的政策指南");
                return;
            }
            try {
                await this.$confirm("确认批量删除选中的政策指南吗？", "提示", {
                    type: "warning",
                });
                const ids = this.selectedPolicyGuides.map((item) => item.id);
                await Promise.all(ids.map((id) => areaPolicyRemove(id)));
                this.$message.success("批量删除成功");
                this.getPolicyGuideList();
                this.selectedPolicyGuides = [];
            } catch (error) {
                if (error !== "cancel") {
                    console.error("批量删除政策指南失败:", error);
                    this.$message.error("批量删除失败");
                }
            }
        },
        // 政策指南分页大小改变
        handlePolicyGuideSizeChange(val) {
            this.policyGuideSize = val;
            this.getPolicyGuideList();
        },
        // 政策指南当前页改变
        handlePolicyGuideCurrentChange(val) {
            this.policyGuideCurrentPage = val;
            this.getPolicyGuideList();
        },
        // 政策指南选择项改变
        handlePolicyGuideSelectionChange(val) {
            this.selectedPolicyGuides = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.platform-container {
    .box-card {
        min-height: 80vh;
    }
    .button-group {
        margin-bottom: 20px;
    }
    .upload-area {
        margin-bottom: 20px;
    }
    .button-group-mt {
        margin-top: 20px;
    }

    .banner-linkUrl {
        display: flex;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;

        .label-name {
            font-size: 14px;
            margin-right: 10px;
            flex-shrink: 0;
        }
    }

    .pagination-container {
        text-align: right;
        margin: 10px 0;
    }
}
</style>

// 在data中添加以下数据 policyGuideList: [], // 政策指南列表数据
policyGuideLoading: false, // 政策指南加载状态 policyGuideTitle: '', //
政策指南搜索标题 policyGuideCurrentPage: 1, // 政策指南当前页 policyGuideSize:
10, // 政策指南每页条数 policyGuideTotal: 0, // 政策指南总条数
selectedPolicyGuides: [], // 选中的政策指南
